import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastProvider } from "./components/CustomToast";
import { AuthProvider } from "./supabase/AuthProvider";
import { UserProfileProvider } from "./context/UserProfileContext";
import { EntitlementsProvider } from "./context/EntitlementsContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider>
    <UserProfileProvider>
      <EntitlementsProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </EntitlementsProvider>
    </UserProfileProvider>
  </AuthProvider>
);
